var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative app-wrapper overflow-x-hidden"},[_c('Header',{attrs:{"menuhideshow":_vm.loginstate = false}}),_c('div',{staticClass:"w-full container mx-auto min-h-600-px"},[_c('div',{},[_c('div',{staticClass:"w-full p-80"},[_c('div',{staticClass:"shadow"},[_c('router-view')],1)])])]),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }